export default __webpack_public_path__ + "static/media/Initiate's Arm-straps of the Heavens.abbf03df.jpg";